// iter_AUTH_ISOLATION (2026-02-28) — Google Sign-In visibility hook.
// Fetches /auth/google/enabled once and caches for the session so the
// three sign-in surfaces (Login, Signup, AcceptInvite) can hide the
// "Continue with Google" button when the backend feature-flag is off.
//
// Defaults to `false` — buttons stay hidden until the backend
// explicitly says the tenant-owned OAuth client is configured. This
// prevents any lingering "emergentagent.com" branded consent screen.

import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let inflight = null;

async function fetchEnabled() {
  if (cached !== null) return cached;
  if (!inflight) {
    inflight = api.get("/auth/google/enabled")
      .then((r) => { cached = !!r.data?.enabled; return cached; })
      .catch(() => { cached = false; return false; });
  }
  return inflight;
}

export function useGoogleSignInEnabled() {
  const [enabled, setEnabled] = useState(cached === null ? false : cached);
  useEffect(() => {
    let alive = true;
    fetchEnabled().then((v) => { if (alive) setEnabled(v); });
    return () => { alive = false; };
  }, []);
  return enabled;
}
